import { useEffect } from "react";
import { useHotkeysContext } from "react-hotkeys-hook";

export const useSuspendGradingScope = (active: boolean): void => {
	const { enableScope, disableScope } = useHotkeysContext();
	useEffect(() => {
		if (!active) return;
		disableScope("grading");
		return () => enableScope("grading");
	}, [active, enableScope, disableScope]);
};
